import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPlannerLoadingSliceState {
    loading: boolean;
}

const initialState: IPlannerLoadingSliceState = {
    loading: false,
};

const plannerLoadingSlice = createSlice({
    name: "plannerLoadingStore",
    initialState,
    reducers: {
        setLoading(state: IPlannerLoadingSliceState, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
    },
});

export const { setLoading } = plannerLoadingSlice.actions;

export default plannerLoadingSlice.reducer;
